// A hindrance's degrees: the points it is worth in a character build and the `value` a
// character.hindrances modification carries — two for Major, one for Minor. A choice-type hindrance
// (or no severity at all) counts as Minor until a severity is picked, the same default
// addDrawbackToCharacter applies.
export const hindranceDegrees = (severity: string | null | undefined): 1 | 2 => (severity === 'major' ? 2 : 1);
